import { ActionTypes } from "../constants/index";

export default function sidechains(
	state = {
		isFetching: true,
	},
	action = ""
) {
	switch (action.type) {
		case ActionTypes.FETCH_LISTINGS_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});
		case ActionTypes.MARKET_FETCH_LISTINGS_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				listings: action.listings,
			});
		case ActionTypes.MARKET_GET_LISTING_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				listing: action.listing,
			});
		case ActionTypes.MARKET_SET_PREVIEW_LISTING:
			return Object.assign({}, state, {
				isFetching: false,
				draftListing: action.draftListing,
			});
		case ActionTypes.MARKET_UPDATE_LISTING:
			const allListings = action.listings || [];
			const isUpdate = allListings.find((ll) => ll.id === action.listing.id);
			const listings = isUpdate
				? allListings.map((item) => {
						return item.id === action.listing.id ? action.listing : item;
				  })
				: [...allListings, action.listing];

			return Object.assign({}, state, {
				listing: action.listing,
				listings,
			});
		case ActionTypes.MARKET_LOGIN_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				user: action.user,
			});
		case ActionTypes.MARKET_LOGOUT_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				user: null,
			});

		default:
			return state;
	}
}
